module.exports = "<div class=\"g-admin-acordion-list\" [ngClass]=\"customClass\">\n  <ng-content></ng-content>\n</div>\n"